import { Button, ProgressBar, Text, Title3 } from '@fluentui/react-components';
import { useStyles } from './styles.js';

type SyncStatusFullscreenProps = {
    progress: number;
    onDismiss: () => void;
};

export function SyncStatusFullscreen({ progress, onDismiss }: SyncStatusFullscreenProps) {
    const styles = useStyles();

    return (
        <div className={styles.backdrop}>
            <div className={styles.card}>
                <Title3 className={styles.title}>
                    {progress > 0 ? 'Synchronisierung läuft' : 'Warte auf Synchronisierung'}
                </Title3>
                <Text className={styles.message}>
                    {progress > 0
                        ? 'Ihre Daten werden aktuell synchronisiert. Der Vorgang wird einmalig durchgeführt und kann bis zu 24 Stunden dauern.'
                        : 'Die Synchronisierung befindet sich noch in der Warteschlange. Der Vorgang wird einmalig durchgeführt und kann bis zu 24 Stunden dauern.'}
                </Text>
                <div className={styles.progressContainer}>
                    <ProgressBar value={progress / 100} thickness="large" className={styles.progressBar} />
                    <Text className={styles.percentage}>{progress}%</Text>
                </div>
                <Button appearance="primary" onClick={onDismiss} className={styles.button}>
                    Im Hintergrund synchronisieren
                </Button>
            </div>
        </div>
    );
}
